export const FOOTER_COPYRIGHT_TEXT =
  'footer_copyright_text_amazon_com_inc_or_its_affiliates';
